import React from 'react'
import { Helmet } from 'react-helmet-async'
import ServicePageTemplate, { ServicePageConfig } from '../../../components/templates/ServicePageTemplate'

const ticketingEventsConfig: ServicePageConfig = {
  title: 'Ticketing & Events - FGA Prestige',
  description: 'Exclusive access to sold-out events and premium experiences.',
  slug: 'ticketing-events',
  heroImage: '/Member Services/Ticketing & Events/hero.png',
  serviceName: 'TICKETING & EVENTS',
  whySectionC: {
    title: 'Your Passport to the Unattainable',
    content: 'But we don\'t stop at the best seats in the house. Our bespoke calendar unlocks a world of invitation-only events, each one produced and hosted by us for those who expect more. Think intimate social drinks in hidden city gems, thought-provoking panel discussions with industry leaders, and supper clubs where every guest is a story waiting to be told.',
    image: '/Member Services/Ticketing & Events/body/3.png',
    imageAlt: 'Exclusive event access and VIP experiences'
  },
  whySectionB: {
    title: '',
    benefits: [
      {
        title: '',
        description: 'Every gathering is meticulously crafted—whether it\'s a private preview, a spirited debate, or a night of culinary discovery. For our members, exclusivity isn\'t just a promise; it\'s a way of life.'
      }
    ],
    image: '/Member Services/Ticketing & Events/body/2.png',
    imageAlt: 'Premium event seating and luxury hospitality services'
  },
  masterpieceBackgroundImage: '/Member Services/Ticketing & Events/CTA Banner/banner.png',
  whySectionA: {
    title: 'Access Granted',
    content: 'We believe the world’s most coveted moments shouldn’t just be attended—they should be experienced from the inside. Our members enjoy front-row access to the globe’s most sought-after happenings, from red-carpet galas to championship showdowns, all with VIP privileges that turn mere attendance into pure immersion.',
    image: '/Member Services/Ticketing & Events/body/1.png',
    imageAlt: 'Exclusive event access and VIP experiences'
  }
}

const TicketingEventsPage: React.FC = () => {
  return (
    <>
      <Helmet>
        <title>Ticketing & Events | Member Services | FGA Prestige</title>
        <meta name="description" content="Exclusive access to sold-out events and premium experiences. VIP concert tickets, private exhibitions, and invitation-only gatherings at FGA Prestige." />
        <link rel="canonical" href="https://fgaprestige.com/member-services/ticketing-events" />
        <meta property="og:title" content="Ticketing & Events | Member Services | FGA Prestige" />
        <meta property="og:description" content="Exclusive access to sold-out events and premium experiences. VIP concert tickets, private exhibitions, and invitation-only gatherings at FGA Prestige." />
        <meta property="og:url" content="https://fgaprestige.com/member-services/ticketing-events" />
        <meta property="og:image" content="/Member Services/Ticketing & Events/hero.png" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
        <meta property="og:image:alt" content="FGA Prestige Ticketing & Events" />
        <meta property="og:type" content="website" />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:title" content="Ticketing & Events | Member Services | FGA Prestige" />
        <meta name="twitter:description" content="Exclusive access to sold-out events and premium experiences. VIP concert tickets, private exhibitions, and invitation-only gatherings at FGA Prestige." />
        <meta name="twitter:image" content="/Member Services/Ticketing & Events/hero.png" />
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "Service",
            "name": "Ticketing & Events",
            "description": "Exclusive access to sold-out events and premium experiences. VIP concert tickets, private exhibitions, and invitation-only gatherings at FGA Prestige.",
            "provider": {
              "@type": "Organization",
              "name": "FGA Prestige",
              "url": "https://fgaprestige.com"
            },
            "url": "https://fgaprestige.com/member-services/ticketing-events",
            "image": "/Member Services/Ticketing & Events/hero.png"
          })}
        </script>
      </Helmet>

      <ServicePageTemplate config={ticketingEventsConfig} />
    </>
  )
}

export default TicketingEventsPage